<template>
  <div ref="container" @keydown.enter.prevent="checkAndSubmit">
    <div class="w-full grow criteria flex flex-col space-y-6 @xl:space-y-3">
      <div v-for="(usc, index) in userSearchCriteria" :key="usc.id" v-show="!usc.hidden" class="nested-form-item">
        <div class="group flex space-x-2 items-center">
          <SearchCriterionFields
            v-bind="generateFieldNames(index)"
            :initial-values="usc.values"
            :criteria="criteria"
            :importances="importances"
            :searchableGroups="searchableGroups"
            :searchableTags="searchableTags"
            :searchableAvailabilities="searchableAvailabilities"
            :programId="programId"
          ></SearchCriterionFields>

          <button type="button" @click="removeEntry(index)" class="button w-10 secondary flex justify-center items-center" :disabled="visibleSearchCriteria.length < 2">
            <i class="fa fa-times h-5 before:h-5 before:leading-5"><span class="sr-only">{{ removeString }}</span></i>
          </button>
        </div>
      </div>
    </div>

    <div class="flex space-x-3 justify-end mt-6">
      <button type="button" @click="addEntry" class="secondary button">
        <i class="fa far fa-plus"></i><span>{{ addString }}</span>
      </button>

      <input type="submit" id="search-button" class="button w-fit" :value="submitString">
    </div>

    <input type="hidden" name="sort_by" :value="sortBy" v-if="sortBy" />
  </div>
</template>

<script setup>
  import { ref, computed } from 'vue'
  import SearchCriterionFields from './SearchCriterionFields.vue'

  const props = defineProps({
    parentModel:              { type: String, required: true, default: 'user_search' },
    initialSearchCriteria:    { type: Array, default: () => [] },
    sortBy:                   { type: String, default: null },
    submitString:             { type: String, default: 'Search' },
    addString:                { type: String, default: 'Add Field' },
    removeString:             { type: String, default: 'Delete criterion' },
    criteria:                 { type: Array, default: () => [] }, // constant arrays
    importances:              { type: Array, default: () => [] },
    searchableTags:           { type: Array, default: () => [] },
    searchableAvailabilities: { type: Array, default: () => [] },
    searchableGroups:         { type: Array, default: () => [] },
    programId:                { type: Number, default: -999 }
  })

  const userSearchCriteria = ref(props.initialSearchCriteria)
  const nextIndex = ref(props.initialSearchCriteria.length)
  const container = ref(null)

  const generateFieldNames = (index) => ({
    fieldIdFieldName: `${props.parentModel}[user_search_criteria_attributes][${index}][field_id]`,
    criterionTextFieldName: `${props.parentModel}[user_search_criteria_attributes][${index}][criterion_text]`,
    criterionValueIdsFieldName: `${props.parentModel}[user_search_criteria_attributes][${index}][criterion_value_ids]`,
    listValueIdsFieldName: `${props.parentModel}[user_search_criteria_attributes][${index}][list_value_ids]`,
    importanceFieldName: `${props.parentModel}[user_search_criteria_attributes][${index}][importance]`
  })

  const addEntry = () => {
    const index = nextIndex.value
    userSearchCriteria.value.push({ id: index })
    nextIndex.value++
  }

  const visibleSearchCriteria = computed(() => {
    return userSearchCriteria.value.filter((usc) => usc.hidden !== true)
  })

  const removeEntry = (index) => {
    if (userSearchCriteria.value[index].persisted) {
      const destroyField = document.createElement('input')
      destroyField.type = 'hidden'
      destroyField.name = `${props.parentModel}[user_search_criteria_attributes][${index}][_destroy]`
      destroyField.value = '1'
      container.value?.appendChild(destroyField)
      userSearchCriteria.value[index].hidden = true
    } else {
      userSearchCriteria.value.splice(index, 1)
    }
  }

  const checkAndSubmit = () => {
    // Check if any dropdown is open
    if (document.querySelectorAll('[data-pc-section="overlay"]').length > 0) {
      return // Don't submit if dropdown is open
    }
    
    const button = document.querySelector("#search-button")
    if (button) {
      button.click() // works with both Turbo and regular forms
    }
  }
</script>
